




































































































































































import Vue from "vue";
import { Input } from "../../../directives/Input";
import { isEmpty } from "lodash";
import { Component } from "vue-property-decorator";
import { PickupsDTO, PickupDetailsDTO } from "../../../model/data.model";
import { getStoreId, getTenantId } from "../../../services/AuthService";
import { CustomerService } from "@/services/CustomerService";
import { required } from "vuelidate/lib/validators";
import { numeric } from "vuelidate/lib/validators";
import { PickupService } from "../../../services/PickupService";
import { translateErrorMessage } from "@/services/Helpers";

@Component({
  directives: {
    MbeInput: Input
  },
  components: {},
  validations() {
    return {
      pickup: {
        pickupDate: {
          required
        },
        pickupTime: {
          required
        },
        packages: {
          required,
          numeric
        },
        totalCustomerWeight: {
          required
        }
      }
    };
  }
})
export default class PickupDetails extends Vue {
  pickup: PickupDetailsDTO = {} as PickupDetailsDTO;
  storeConfig = {
    minCutOffTime: "00:01",
    maxCutoffTime: "23:59",
    minPickupTime: "",
    maxPickupTime: ""
  };
  isDepartmentMandatory: boolean = this.$store.getters["customer/config"]
    .isDepartmentMandatory;
  selectedDepartment: any = {};

  created() {
    const storeCustomerConfig = this.$store.getters["customer/config"];

    if (storeCustomerConfig) {
      this.storeConfig = {
        minCutOffTime: storeCustomerConfig.pickupCutOffMin.substr(0, 5),
        maxCutoffTime: storeCustomerConfig.pickupCutOffMax.substr(0, 5),
        minPickupTime: storeCustomerConfig.pickupMinTime.substr(0, 5),
        maxPickupTime: storeCustomerConfig.pickupMaxTime.substr(0, 5)
      };
    }
  }

  get id() {
    return this.$route.params.id;
  }

  get minimumPickupTime() {
    if (!this.pickupToday) return this.storeConfig.minPickupTime;
    const today = new Date();
    let hour: number | string = today.getHours();
    let minutes: number | string = today.getMinutes();
    if (
      `${("0" + hour.toString()).slice(-2)}:${("0" + minutes.toString()).slice(
        -2
      )}` < this.storeConfig.minPickupTime
    ) {
      return this.storeConfig.minPickupTime;
    }
    hour = minutes > 45 ? (hour === 23 ? 0 : ++hour) : hour;
    minutes = (Math.ceil(minutes / 15) * 15) % 60;
    hour = `0${hour}`.slice(-2);
    minutes = `0${minutes}`.slice(-2);
    return `${hour}:${minutes}`;
  }

  getTimePickerOptionsPickup() {
    return {
      start: this.minimumPickupTime,
      step: "00:15",
      end: this.storeConfig.maxPickupTime
    };
  }

  get pickupToday() {
    const pickupDate = new Date(this.pickup.pickupDate);
    pickupDate.setHours(0, 0, 0, 0);
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    return pickupDate.getTime() === currentDate.getTime();
  }

  datePickerOptions(date: any) {
    if (!this.storeConfig.maxCutoffTime) {
      this.storeConfig.maxCutoffTime = "23:59";
    }

    let today = new Date();
    if (
      `${("0" + today.getHours().toString()).slice(-2)}:${(
        "0" + today.getMinutes().toString()
      ).slice(-2)}` > this.storeConfig.maxCutoffTime
    ) {
      const tomorrow = today.getDate() + 1;
      today = new Date(today.setDate(tomorrow));
    }
    today.setHours(0, 0, 0, 0);
    return {
      disabledDate(time: Date) {
        time.setHours(0, 0, 0, 0);
        return time.getTime() < today.getTime();
      },
      firstDayOfWeek: 1
    };
  }
  handleDepartmentsSearch(search: any) {
    this.selectedDepartment = search;

    if (search === undefined || search === "" || search.length < 3) {
      return;
    }

    const searchInput = search.toLowerCase();
    CustomerService.loadCustomerDepartments(
      this.$store,
      this.$t("no_department").toString(),
      0,
      searchInput
    );
  }

  // Save
  get saveDisable() {
    if (this.$v.$invalid) {
      return true;
    }

    return false;
  }
  // Save
  savePickup() {
    this.pickup.tenantId = getTenantId();
    this.pickup.customerId = this.$store.getters["customer/info"].customerId;
    this.pickup.storeId = getStoreId();
    this.pickup.departmentId = this.selectedDepartment
      ? this.selectedDepartment.departmentId
      : undefined;
    this.pickup.departmentBusinessName = this.selectedDepartment
      ? this.selectedDepartment.departmentBusinessName
      : undefined;
    PickupService.savePickup(
      this.pickup,
      this.$store.getters["customer/config"].username,
      this.$store.getters["customer/config"].language
    )
      .then((pickup: PickupDetailsDTO) => {
        if (pickup?.messageResult?.messages.length > 0) {
          let title = "";
          pickup.messageResult.messages.forEach((mex: any) => {
            let message = String(this.$t(mex.code));
            if (mex.responseType === "ERROR") {
              // for courier exception(s) that can have unknown errors from ext. systems
              if (!this.$t(mex.code)) {
                let msgCode = mex.code;
                if (mex.code === undefined) {
                  msgCode = this.$t("UNEXPECTED_ERROR");
                }
                message = msgCode + " " + mex.description;
              }
            }
            title += "<li>" + message + "</li>";
          });
          this.$alerts.danger(title);
        } else {
          this.$router.push({ name: "PickupsList" });
          this.$snotify.success("Pickup has been created.");
        }
      })
      .catch(err => {
        this.$snotify.error(translateErrorMessage(err));
      });
  }
  checkClearDate() {
    if (!this.pickup.pickupDate) this.pickup.pickupTime = null;
  }
  handleDepartmentsClear(event: any) {
    if (isEmpty(event)) {
      CustomerService.loadCustomerDepartments(
        this.$store,
        this.$t("no_department").toString()
      );
    }
  }
  get departments() {
    return this.$store.getters["customer/departments"];
  }
}
